<template>
  <b-card no-body class="p-2">
    <h3 class="mb-2">
      {{
        profile.perfilId == 0
          ? $t("Routes.ProfileAdd")
          : $t("Routes.ProfileEdit")
      }}
    </h3>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <b-form
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="resetForm"
      >
        <b-row>
          <!-- name work area field -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              :name="$t('humanResources.profile.columns.name')"
              rules="required"
            >
              <b-form-group
                :label="$t('humanResources.profile.columns.name')"
                :state="errors.length > 0 ? false : null"
              >
                <b-form-input v-model="profile.nombre" />
                <b-form-invalid-feedback
                  :state="errors.length > 0 ? false : null"
                >
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="6">
            <validation-provider
              #default="{ errors }"
              :name="$t('humanResources.profile.columns.gender')"
              rules="required"
            >
              <b-form-group
                :label="$t('humanResources.profile.columns.gender')"
                :state="errors.length > 0 ? false : null"
              >
                <v-select
                  id="usuario"
                  v-model="profile.generoId"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="texto"
                  :options="geders"
                  :reduce="(option) => option.id"
                />
                <b-form-invalid-feedback
                  :state="errors.length > 0 ? false : null"
                >
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="6">
            <validation-provider
              #default="{ errors }"
              :name="$t('humanResources.profile.columns.maritalStatus')"
              rules="required"
            >
              <b-form-group
                :label="$t('humanResources.profile.columns.maritalStatus')"
                :state="errors.length > 0 ? false : null"
              >
                <v-select
                  id="usuario"
                  v-model="profile.estadoCivilId"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="texto"
                  :options="maritalStatus"
                  :reduce="(option) => option.id"
                />
                <b-form-invalid-feedback
                  :state="errors.length > 0 ? false : null"
                >
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="6">
            <validation-provider
              #default="{ errors }"
              :name="$t('humanResources.profile.columns.minimumAge')"
            >
              <b-form-group
                :label="$t('humanResources.profile.columns.minimumAge')"
                :state="errors.length > 0 ? false : null"
              >
                <b-form-input
                  v-model="profile.edadMinima"
                  type="number"
                />
                <b-form-invalid-feedback
                  :state="errors.length > 0 ? false : null"
                >
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="6">
            <validation-provider
              #default="{ errors }"
              :name="$t('humanResources.profile.columns.maxiumAge')"
            >
              <b-form-group
                :label="$t('humanResources.profile.columns.maxiumAge')"
                :state="errors.length > 0 ? false : null"
              >
                <b-form-input
                  v-model="profile.edadMaxima"
                  type="number"
                />
                <b-form-invalid-feedback
                  :state="errors.length > 0 ? false : null"
                >
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- Description Field -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="Description"
              rules="required"
            >
              <b-form-group
                :label="$t('humanResources.profile.columns.description')"
                :state="errors.length > 0 ? false : null"
              >
                <b-form-textarea v-model="profile.descripcion" />
                <b-form-invalid-feedback
                  :state="errors.length > 0 ? false : null"
                >
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row class="float-right mt-2 mb-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
          >
            <b-spinner v-if="addingProfile" small class="mr-1" />
            {{ profile.perfilId == 0 ? $t("Lists.Add") : $t("Lists.Edit") }}
          </b-button>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BCard,
  BForm,
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  BFormTextarea,
  BSpinner,
  BFormInvalidFeedback,
  BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import humanResources from '@/services/humanresources.service'
import optionService from '@/services/option.service'
import vSelect from 'vue-select'
import formValidation from '@core/comp-functions/forms/form-validation'
import { required } from '@validations'
import router from '@/router'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormInput,
    BFormInvalidFeedback,
    BFormGroup,
    BFormTextarea,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,

    vSelect,
  },
  setup() {
    const geders = ref([])
    const maritalStatus = ref([])
    const addingProfile = ref(false)
    const profile = ref({
      perfilId: 0,
      generoId: 0,
      estadoCivilId: 0,
      nombre: '',
      descripcion: '',
      edadMinima: '',
      edadMaxima: '',
      archivado: false,
    })

    const blankProfile = {
      perfilId: 0,
      generoId: 0,
      estadoCivilId: 0,
      nombre: '',
      descripcion: '',
      edadMinima: '',
      edadMaxima: '',
      archivado: false,
    }

    const {
      fetchProfile,
      createProfile,
      updateProfile,
    } = humanResources()

    const {
      fetchOptions,
    } = optionService()

    const resetProfile = () => {
      profile.value = JSON.parse(JSON.stringify(blankProfile))
    }

    if (router.currentRoute.params.perfilId) {
      fetchProfile(router.currentRoute.params.perfilId, data => {
        profile.value = data
      })
    } else {
      profile.value = JSON.parse(JSON.stringify(blankProfile))
    }
    fetchOptions({ nombreDominio: 'Genero' }, data => {
      geders.value = data
    })
    fetchOptions({ nombreDominio: 'RecursosHumanosEstadosCiviles' }, data => {
      maritalStatus.value = data
    })
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetProfile)

    const onSubmit = () => {
      addingProfile.value = true
      if (profile.value.perfilId === 0) {
        createProfile(profile.value, () => {
          addingProfile.value = false
          router.push({ name: 'apps-human-resources-profile-list' })
        })
      } else {
        updateProfile(profile.value.perfilId, profile.value, () => {
          addingProfile.value = false
          router.push({ name: 'apps-human-resources-profile-list' })
        })
      }
    }

    return {
      geders,
      maritalStatus,
      profile,
      addingProfile,
      required,
      getValidationState,
      refFormObserver,
      resetForm,
      onSubmit,

    }
  },
}
</script>
